module.exports = __webpack_public_path__ + "img/4.00d23ed2.png";